import cart from './model/cart';
import product from './model/product';
import swatches from './model/swatches';

//
//  Init models
//  _____________________________________________

product.init();
cart.init();
swatches.init();
